/**
 * SMS Service - API client for sending SMS notifications and
 * viewing SMS delivery history
 */
import api from '../utils/api';

const smsService = {
  getRecipients: async (announcementId) => {
    try {
      return await api.get('/api/sms/recipients', { params: { announcement_id: announcementId } });
    } catch (error) {
      console.error('Error fetching SMS recipients:', error);
      throw error;
    }
  },

  listNotifications: async (params = {}) => {
    try {
      return await api.get('/api/sms/notifications', { params });
    } catch (error) {
      console.error('Error fetching SMS notifications:', error);
      throw error;
    }
  },

  getStatistics: async () => {
    try {
      return await api.get('/api/sms/statistics');
    } catch (error) {
      console.error('Error fetching SMS statistics:', error);
      throw error;
    }
  },

  sendFeeReminder: async (data) => {
    try {
      return await api.post('/api/sms/fee-reminder', data);
    } catch (error) {
      console.error('Error sending fee reminder SMS:', error);
      throw error;
    }
  },

  sendAttendanceAlert: async (data) => {
    try {
      return await api.post('/api/sms/attendance-alert', data);
    } catch (error) {
      console.error('Error sending attendance alert SMS:', error);
      throw error;
    }
  },

  sendAnnouncement: async (data) => {
    try {
      return await api.post('/api/sms/announcement', data);
    } catch (error) {
      console.error('Error sending announcement SMS:', error);
      throw error;
    }
  }
};

export default smsService;
